import { useEffect, useState } from "react";
import Form1 from "../components/Form/Form1";
import Form2 from "../components/Form/Form2";
import Form3 from "../components/Form/Form3";
import Done from "../components/Form/Done";
import PageWrapper from "../components/PageWrapper";
import useReservationState, { UTMParams } from "../util/useReservationState";
import useAsyncUpdate from "../util/useAsyncUpdate";
import { Group } from "../api/ApiData";
import { useCookies } from "react-cookie";
import Time from "../util/Time";
import FormError from "../components/Form/FormError";
import { useApiContext } from "../api/ApiProvider";

export default function TopPage() {
  const { api } = useApiContext();
  const [cookies] = useCookies(["_fbp"]);
  const [group] = useAsyncUpdate(api.GetGroup);
  const [fbc, setFbc] = useState<string>();
  const searchParams = new URLSearchParams(window.location.search);
  const utmSource = searchParams.get("utm_source") || "";
  const utmMedium = searchParams.get("utm_medium") || "";
  const utmCampaign = searchParams.get("utm_campaign") || "";
  const utmTerm = searchParams.get("utm_term") || "";
  const utmContent = searchParams.get("utm_content") || "";
  const fbclid = searchParams.get("fbclid") || undefined;
  const fbp = cookies["_fbp"] || undefined;
  const utmParams: UTMParams = { utmSource, utmMedium, utmCampaign, utmTerm, utmContent };

  if (fbc === undefined && fbclid !== undefined) {
    setFbc(`fb.1.${Time.Now().getTime()}.${fbclid}`);
  }

  if (group) {
    return <Loaded group={group} utmParams={utmParams} fbc={fbc} fbp={fbp} />;
  }
  return <></>;
}

function Loaded({ group, utmParams, fbc, fbp }: { group: Group; utmParams: UTMParams; fbc?: string; fbp?: string }) {
  const state = useReservationState(group, utmParams, fbc, fbp);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state.form]);

  document.title = `ご予約 -${group.name}-`;
  return (
    <div>
      <PageWrapper storeGroupName={state.data.group.show_group_name ? state.data.group.name : ""}>
        {(() => {
          switch (state.form) {
            case 1:
              return <Form1 state={state} />;
            case 2:
              return <Form2 state={state} />;
            case 3:
              return <Form3 state={state} />;
            case "done":
              return <Done state={state} />;
            case "error":
              return <FormError state={state} />;
          }
        })()}
      </PageWrapper>
    </div>
  );
}
